module.exports = __webpack_public_path__ + "img/admin_panel_settings_opsz24.60e6b2f1.svg";